<template>
    <div class="w-100 px-5 ý-4">
        <div>
            <h1>VÍDEO DE PRUEBA PARA SALA</h1>
            <h3>{{SesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre}} {{SesionDeLaAudiencia.Audiencia.Consecutivo}} </h3>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="area">
                    <div class="row col-12">
                        <div class="col-4">
                            <label>Tipo de Audiencia</label>
                            <input type="text" class="form-control" v-model="SesionDeLaAudiencia.Audiencia.TipoAudiencia.Nombre" readonly />
                        </div>
                        <div class="col-4">
                            <label>Fecha</label>
                            <input type="text" class="form-control" v-model="Fecha" readonly/>
                        </div>
                        <div class="col-4">
                            <label>Sala</label>
                            <input type="text" class="form-control" v-model="SesionDeLaAudiencia.Sala.Nombre" ref=""/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 padding-div-low" v-if="SesionDeLaAudiencia.SesionDeLaAudienciaId != null">
                <div class="area">
                    <div class="cams-manage">
                        <div class="cam col-12">
                            <video id='video_id' ref="videoPlayer" controls playsinline :poster='require("@/../src/assets/logo-pj-transparente-blanco.png")'>
                                <source :src="rutaVideoPrueba" type="video/mp4" />
                                HTML5 El vídeo no es soportado por le navegador, por favor intenta con Google Chrome
                            </video>    
                        </div>
                    </div>
                    <br/>
                    <div class="text-right">
                        <button class="btn btn-sm btn-dark"  @click='regresarEdicion()'>Volver a Validación de Audiencia</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas';
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'
import RouterForseti from '@/router/index'

export default ({
    components: {
      Reproductor: sistemas.Forseti.Reproductor,
      RouterForseti
    },
    data() {
        return {
            comun,
            enumeraciones,            
            SesionDeLaAudiencia: {
                SesionDeLaAudienciaId: null,
                Audiencia: {
                    TipoDocumento:{Nombre : ""},
                    TipoAudiencia: {Nombre: ""},
                    Consecutivo: ""
                },
                
                Sala: { Nombre: "" },
                Marcadores: []
            },
            rutaVideoPrueba: null,
            Fecha: "" 
        }
    },
    props:{
        SesionId: Number
    },
    mounted(){
        this.obtenerSesion();
    },
    methods:{
        async obtenerSesion() { 
            comun.SeEstaCargandoInformacion(true);
            const parametros = {
                SesionDeLaAudienciaId: this.SesionId,
                EsPrueba: this.enumeraciones.EsPrueba
            };

            axios.post(
                api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.ObtenSesionDeLaAudienciaPorVerificar,
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
                comun.SeEstaCargandoInformacion(false);

                if (respuesta.data.SiHayError) {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                } else { 
                    this.SesionDeLaAudiencia = respuesta.data.SesionDeLaAudienciaPendiente;
                    this.Fecha = this.fechaConFormato(respuesta.data.SesionDeLaAudienciaPendiente.Audiencia.FechaAudiencia)
                    //console.log(this.SesionDeLaAudiencia);
                    //this.rutaVideoPrueba = this.SesionDeLaAudiencia.RutasDeVideos[0].Ruta.replace(".mp4", "_PruebaSala.mp4");
                    var ruta = this.SesionDeLaAudiencia.RutasDeVideos[0].Ruta.replace(".mp4", "_PruebaSala.mp4");
                    this.cargarVideo(ruta)                                 
                }
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });    
        },
        cargarVideo(ruta) {
            const ObtenerVideo = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ruta}`;
            try {
                    axios.get(ObtenerVideo, { responseType: 'blob' })
                    .then(respuesta => { 
                      this.rutaVideoPrueba = URL.createObjectURL(new Blob([respuesta.data], {type: 'video/mp4'}))
                      var videoPlayer = document.getElementById('video_id');
                      videoPlayer.src = this.rutaVideoPrueba;
                      videoPlayer.load();
                      comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                      comun.SeEstaCargandoInformacion(false);
                                console.log(excepcion);
                                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    })
              }
              catch(exeption) {
                      comun.SeEstaCargandoInformacion(false);
                      console.log(exeption);
              }
        },
        fechaConFormato(fecha){
            return moment(fecha).format('DD/MM/YYYY HH:MM')
        },
        regresarEdicion(){
            RouterForseti.push({ name: 'EdicionYAsignacion', params: {AudienciaId: this.SesionDeLaAudiencia.Audiencia.AudienciaId}})
        }
    }
})
</script>
<style scoped>
  .cams-manage {
    display: flex;
    flex-wrap: wrap;
  }

  .cam video {
    width: 100%;
    height: 100%;
  }

  .cam {
    padding: 0;
    background-color: #000;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 4em;
    border: 4px solid #323335;
  }
  input[type="text"]:read-only {
    background: #504f54;
  }

  input[type="text"]:read-only:focus {
    color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/VisorVideoPrueba.vue